module.exports = __webpack_public_path__ + "img/bot_icon_online.ad610d3a.svg";